'use strict';

jQuery(document).ready(function ($) {

    var sliderId = '#slider-promo';

    /*$('#slider-promo').slick({
        dots: true,
        infinite: true,
        arrows: false,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        swipetoslide: true,
        swipe: true,
        fade: true,
        pauseOnHover: false
    });*/
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInByb21vLXNsaWRlci5qcyJdLCJuYW1lcyI6WyJqUXVlcnkiLCJkb2N1bWVudCIsInJlYWR5IiwiJCIsInNsaWRlcklkIl0sIm1hcHBpbmdzIjoiOztBQUFBQSxPQUFPQyxRQUFQLEVBQWlCQyxLQUFqQixDQUF1QixVQUFVQyxDQUFWLEVBQWE7O0FBRWhDLFFBQUlDLFdBQVcsZUFBZjs7QUFFQTs7Ozs7Ozs7Ozs7Ozs7QUFjSCxDQWxCRCIsImZpbGUiOiJwcm9tby1zbGlkZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJqUXVlcnkoZG9jdW1lbnQpLnJlYWR5KGZ1bmN0aW9uICgkKSB7XHJcblxyXG4gICAgdmFyIHNsaWRlcklkID0gJyNzbGlkZXItcHJvbW8nO1xyXG5cclxuICAgIC8qJCgnI3NsaWRlci1wcm9tbycpLnNsaWNrKHtcclxuICAgICAgICBkb3RzOiB0cnVlLFxyXG4gICAgICAgIGluZmluaXRlOiB0cnVlLFxyXG4gICAgICAgIGFycm93czogZmFsc2UsXHJcbiAgICAgICAgc3BlZWQ6IDcwMCxcclxuICAgICAgICBzbGlkZXNUb1Nob3c6IDEsXHJcbiAgICAgICAgc2xpZGVzVG9TY3JvbGw6IDEsXHJcbiAgICAgICAgYXV0b3BsYXk6IHRydWUsXHJcbiAgICAgICAgYXV0b3BsYXlTcGVlZDogNTAwMCxcclxuICAgICAgICBzd2lwZXRvc2xpZGU6IHRydWUsXHJcbiAgICAgICAgc3dpcGU6IHRydWUsXHJcbiAgICAgICAgZmFkZTogdHJ1ZSxcclxuICAgICAgICBwYXVzZU9uSG92ZXI6IGZhbHNlXHJcbiAgICB9KTsqL1xyXG59KTsiXX0=